import {Button, DataStatus} from 'platform/components';
import {Heading, Show, Text, VStack} from 'platform/foundation';

import {suffixTestId, TestIdProps, useRequiredParams, useToggle} from 'shared/web';

import {useCatalogue} from '../../../hooks/useCatalogue';
import i18n from '../../../i18n/i18n';
import {useGetCarFeaturesListQuery} from '../../../store/priceReportApi';
import {AllFeaturesFiled} from './AllFeaturesFiled';
import {FeaturesField} from './FeaturesField';

export function VehicleFeatures(props: TestIdProps) {
  const {requestId} = useRequiredParams();
  const {hasFeatureTranslation} = useCatalogue();
  const [isOpen, toggleOpen] = useToggle();
  const {data, isLoading, isError} = useGetCarFeaturesListQuery({id: requestId});
  const translatableFeatures = data?.features?.filter(hasFeatureTranslation) ?? [];

  return (
    <VStack spacing={6} align="flex-start">
      <Heading size={2}>{i18n.t('page.create.labels.vehicleFeatures')}</Heading>
      <Text color="secondary">{i18n.t('page.create.labels.vehicleFeaturesDescription')}</Text>
      <DataStatus isLoading={isLoading} isError={isError}>
        <Heading size={4}>{i18n.t('page.create.labels.selectFeatures')}</Heading>
        <FeaturesField
          features={translatableFeatures}
          data-testid={suffixTestId('featuresField', props)}
        />
        <Button
          title={i18n.t('page.create.labels.showAllFeatures')}
          variant="ghostLink"
          rightIcon={isOpen ? 'navigation/expand_less' : 'navigation/expand_more'}
          onClick={toggleOpen}
          data-testid={suffixTestId('showAllFeatures', props)}
        />
        <Show when={isOpen}>
          <AllFeaturesFiled data-testid={suffixTestId('allFeaturesFiled', props)} />
        </Show>
      </DataStatus>
    </VStack>
  );
}
